export const domain = import.meta.env.VITE_DOMAIN_NAME
export const auth0Domain = import.meta.env.VITE_AUTH0_API_DOMAIN
export const auth0ClientID = import.meta.env.VITE_AUTH0_WEB_CLIENT_ID
export const baseURL = 'https://' + import.meta.env.VITE_DOMAIN_NAME + '/v1/';
export const CDN = "https://"+import.meta.env.VITE_CDN_URL+"/diplayfield/";
